<div class="theme-quick-editor" [class.theme-quick-editor--expanded]="isExpanded">
  <button
    type="button"
    class="theme-quick-editor__toggle"
    [hidden]="isExpanded"
    [attr.aria-expanded]="isExpanded"
    [attr.aria-label]="'i18n.domain.theme-showcase.tenantTheme.quickEditor.toggleLabel' | translate"
    (click)="toggleExpanded()">
    <span class="icon-color-palette" aria-hidden="true"></span>
  </button>

  @if (hasBeenOpened) {
    <div
      class="theme-quick-editor__panel card"
      [class.theme-quick-editor__panel--hidden]="!isExpanded"
      [attr.aria-hidden]="!isExpanded"
      [formGroup]="quickEditorForm">
      <div class="card-header d-flex align-items-center justify-content-between gap-2">
        <span>{{ 'i18n.domain.theme-showcase.tenantTheme.quickEditor.title' | translate }}</span>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary icon-btn"
          [attr.aria-label]="'i18n.domain.theme-showcase.tenantTheme.quickEditor.close' | translate"
          (click)="toggleExpanded()">
          <span class="icon-close" aria-hidden="true"></span>
        </button>
      </div>
      <div class="card-body">
        <div class="mb-3">
          <label class="form-label" for="quickEditorVariable">{{ 'i18n.domain.theme-showcase.tenantTheme.quickEditor.variable' | translate }}</label>
          <ejs-dropdownlist
            id="quickEditorVariable"
            [dataSource]="variableOptions"
            [fields]="dropdownFields"
            formControlName="variable"
            [allowFiltering]="true">
          </ejs-dropdownlist>
        </div>

        <div class="mb-3" [hidden]="isBrandVariableSelected">
          <small class="text-body-secondary d-block">
            {{ 'i18n.domain.theme-showcase.tenantTheme.quickEditor.editingForMode' | translate }}
            <strong>{{ currentModeTranslationKey | translate }}</strong>
          </small>
        </div>

        <div class="mb-3">
          <app-color-picker-field
            id="quickEditorValue"
            [labelKey]="'i18n.domain.theme-showcase.tenantTheme.quickEditor.value'"
            [value]="quickEditorForm.controls.value.value"
            (valueChange)="onValueChanged($event)">
          </app-color-picker-field>
        </div>

        <div class="row">
          @if (isBrandVariableSelected) {
            <div class="col-12">
              <button type="button" class="btn btn-outline-secondary w-100" (click)="resetBrandColor()">
                {{ 'i18n.domain.theme-showcase.tenantTheme.quickEditor.resetButton' | translate }}
              </button>
            </div>
          } @else if (isTokenUpdateCase) {
            <div class="col-6">
              <button type="button" class="btn btn-primary w-100" (click)="save()">
                {{ saveButtonLabelKey | translate }}
              </button>
            </div>
            <div class="col-6">
              <button type="button" class="btn btn-outline-danger w-100" (click)="deleteTokenOverride()">
                {{ 'i18n.domain.theme-showcase.tenantTheme.override.removeButton' | translate }}
              </button>
            </div>
          } @else {
            <div class="col-12">
              <button type="button" class="btn btn-primary w-100" (click)="save()">
                {{ saveButtonLabelKey | translate }}
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
